var map = {
	"./Mahindra-Tractors-Logo.png": 9165,
	"./eicher-logo-new.png": 9465,
	"./garud_logo_new.png": 1062,
	"./mahindra-logo.jpeg": 5437,
	"./sawraj.png": 5414,
	"./sonalika_logo.png": 8032
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5538;